// Network entry points for the bundled embed. Each returns the exact payload
// shape its iframe-page counterpart consumes, so the replicated views can use
// them as drop-in replacements for getServerSideProps:
//   fetchSeoEmbed        -> getSocialCards     (grid / carousel / slider)
//   fetchSeoEmbedAvatars -> getSocialAvatars   (avatars)
function buildQuery(params) {
  const query = new URLSearchParams();

  Object.keys(params || {}).forEach((key) => {
    const value = params[key];

    if (value !== undefined && value !== null && value !== '') {
      query.set(key, value);
    }
  });

  return query.toString();
}

async function fetchEmbedRoute(apiOrigin, route, params) {
  const origin = String(apiOrigin || '').replace(/\/$/, '');
  const url = `${origin}${route}?${buildQuery(params)}`;
  const response = await fetch(url, { credentials: 'omit' });

  if (!response.ok) {
    let message = `Request failed with status ${response.status}`;

    try {
      const body = await response.json();

      if (body && body.msg) {
        message = body.msg;
      }
    } catch (err) {
      // keep the status-based message
    }

    throw new Error(message);
  }

  return response.json();
}

// { status, results, results_count, wall, ... } - the same shape getSocialCards
// returns, so the wall / carousel / slider views use it as a drop-in.
export async function fetchSeoEmbed(apiOrigin, params) {
  return fetchEmbedRoute(apiOrigin, '/api/seo-embed', params);
}

// { status, results, results_count, wall, ... } - the social-proof avatar
// payload getSocialAvatars returns, for the avatars view.
export async function fetchSeoEmbedAvatars(apiOrigin, params) {
  return fetchEmbedRoute(apiOrigin, '/api/seo-embed-avatars', params);
}
